<template>
  <el-dialog
    class="dialog-container"
    title="分配国家"
    :visible.sync="dialogVisible"
    append-to-body
    width="600px"
  >
    <el-tree
      ref="countryTree"
      :data="treeData"
      show-checkbox
      node-key="countryId"
      :props="defaultProps"
      :filter-node-method="filterNode"
      :default-expanded-keys="expandedKeys"
      @check="handleCheck"
      v-loading="loading"
    >
    </el-tree>
    <div slot="footer" class="dialog-footer-button">
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        确定
      </el-button>
      <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAreaCountryTree, activitySupportAssignCountry, kdactivitySupportGetCountries } from "@/api/seek";

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      activityId: "",
      treeData: [],
      checkedCountryIds: [],
      expandedKeys: [],
      filterText: "",
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.countryTree.filter(val);
    }
  },
  methods: {
    async init(row) {
      this.activityId = row.activityId || row.id;
      this.dialogVisible = true;
      this.loading = true;
      this.filterText = "";
      this.checkedCountryIds = [];
      this.expandedKeys = [];

      try {
        const treeRes = await getAreaCountryTree({ data: {} });
        if (treeRes.status == 0) {
          // 转换数据结构以匹配 el-tree
          this.treeData = (treeRes.data || []).map(area => ({
            areaId: area.areaId,
            label: area.areaName,
            children: (area.children || []).map(country => ({
              countryId: country.countryId,
              label: country.cnName
            }))
          }));
          this.expandedKeys = this.treeData.map(item => item.areaId);
        }

        const checkedRes = await kdactivitySupportGetCountries({
          data: { activityId: this.activityId }
        });
        if (checkedRes.status == 0 && checkedRes.data) {
          this.checkedCountryIds = checkedRes.data;
        }

        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.countryTree) {
              this.$refs.countryTree.setCheckedKeys(this.checkedCountryIds);
            }
          }, 100);
        });
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label && data.label.indexOf(value) !== -1;
    },
    handleCheck() {
      const checkedNodes = this.$refs.countryTree.getCheckedNodes();
      this.checkedCountryIds = checkedNodes
        .filter(node => node.countryId)
        .map(node => node.countryId);
    },
    async handleSave() {
      const checkedNodes = this.$refs.countryTree.getCheckedNodes();
      const countryIds = checkedNodes
        .filter(node => node.countryId)
        .map(node => node.countryId);

      this.saveLoading = true;
      try {
        const res = await activitySupportAssignCountry({
          data: {
            activityId: this.activityId,
            countryIds: countryIds
          }
        });
        if (res.status == 0) {
          this.dialogVisible = false;
          this.$DonMessage.success("分配成功！");
          this.$emit("success");
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
      this.saveLoading = false;
    }
  }
};
</script>
